import React, { useEffect, useState, useContext } from "react";
import projectService from "../../services/api/projects-service";
import {useHistory} from "react-router-dom";
import AddUser from './AddUser';
import ProjectContext from '../../ProjectContext'
import ReactBSAlert from "react-bootstrap-sweetalert";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash,faTrashRestoreAlt } from '@fortawesome/free-solid-svg-icons'
import './settings.css';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";


const Users = (props)=> {
  const history = new useHistory();
  const projectDetails = useContext(ProjectContext);
  if(projectDetails.id==''){
    history.push("/project/allprojects");
  }
  let getProjectSlug = new URLSearchParams(props.location.search).get('project');
  if(!getProjectSlug){
    history.push({
      search: '?project='+projectDetails.slug
    })
  }
  const projectId = projectDetails.id;
  const [users, setUsers] = useState(false);
  const [addUser, setShowAddUser] = useState(false);
  const [renderComponent,setRenderComponent] = useState(false);
  const [showPopup,setShowPopup] = useState({alert:null});
  const [reloadComponent,setReloadComponent] = useState(0);
  
  useEffect( () => {
    (async () =>{
        let usersData = await projectService.getProjectUsers(projectId);
            if(usersData.status && usersData.data){
                setUsers(usersData.data);
            }
            setRenderComponent(true);
        })();
    }, [reloadComponent]);

    const suspendUserPopup = (userId) => {
      setShowPopup({
        alert: (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => suspendUser(userId)}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Yes, Suspend/Remove it!"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
            You want to suspend/remove this user!
          </ReactBSAlert>
        ),
      });
    }

    const restoreUserPopup = (userId) => {
      setShowPopup({
        alert: (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure?"
            onConfirm={() => restoreUser(userId)}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Yes, restore it!"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
            You want to provide access to this user again!
          </ReactBSAlert>
        ),
      });
    }

    const suspendUser = async (userId) => {
      let susUser = await projectService.suspendUserFromProject(projectId,userId);
      if(projectDetails.isContractExpired){
        setShowPopup({alert:null});
        projectDetails.setContractExpiredAlert(projectDetails);
      }
      else if(susUser.status && susUser.data.deleted){
        setShowPopup({
          alert: (
            <ReactBSAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Suspended/Removed!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              User was suspended/removed successfully.
            </ReactBSAlert>
          ),
        });
          setReloadComponent(Math.random());
      }else{
        setShowPopup({
          alert: (
            <ReactBSAlert
              danger
              style={{ display: "block", marginTop: "-100px" }}
              title="Please try again!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              User could not be suspended. Please try again.
            </ReactBSAlert>
          ),
        });
      }
    }

    const restoreUser = async (userId) => {
      let resUser = await projectService.restoreUserToProject(projectId,userId);
      if(projectDetails.isContractExpired){
        setShowPopup({alert:null});
        projectDetails.setContractExpiredAlert(projectDetails)
      }
      else if(resUser.status && resUser.data.restored){
        setShowPopup({
          alert: (
            <ReactBSAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Restored!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              User was restored to the project successfully.
            </ReactBSAlert>
          ),
        });
        setReloadComponent(Math.random());
      }else{
        setShowPopup({
          alert: (
            <ReactBSAlert
              danger
              style={{ display: "block", marginTop: "-100px" }}
              title="Please try again!"
              onConfirm={() => hideAlert()}
              onCancel={() => hideAlert()}
              confirmBtnBsStyle="info"
              btnSize=""
            >
              User could not be restored. Please try again.
            </ReactBSAlert>
          ),
        });
      }
    }

    const hideAlert = () => {
      setShowPopup({
        alert: null,
      });
    };  
 

  let userElements = [];
  if(!users || !users.length){
    if(!renderComponent){
        userElements.push(
        <td colSpan="4" className="text-center">
            <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner>
        </td>
      );
    }else{
        userElements.push(
        <td colSpan="4" className="text-center">
            <CardTitle tag="h4">No user found</CardTitle>
        </td>
    );
    }
  }else{
      let i=1;
      users.forEach(function(userDetails) {
        let className = '';
        if(userDetails.status==0){
            className = 'table-danger';
        }
        let displayRoles = [];
        userDetails.roles.forEach(function(roledisplay){
          console.log(roledisplay)
          displayRoles.push(
            <span>{roledisplay.toUpperCase() }</span>
            );
        })
        let actions = true;
        if(userDetails.roles.includes('owner')){
          actions = false;
        }
        userElements.push(
            <tr className={className}>
               <td className="text-left">{i}</td>
               <td className="text-left">
                   {userDetails.name}
               </td>
               <td className="text-left">
                   {userDetails.email}
               </td>
               <td className="text-left">
               {displayRoles}
               </td>
               <td className="text-left">
                   {userDetails.status==1?'Active':'Suspended'}
               </td>
               {actions?
               <td className="text-center">
               {userDetails.status==1?
               <a title="Suspend/Remove" onClick={(event)=>  suspendUserPopup(userDetails.publisher_id) } href="javascript:void(0)" class="dlIcn">
               {/* <i class="nc-icon nc-simple-remove"></i> */}
               {/* <FontAwesomeIcon icon={faTrash} /> */}
               <i class="fa fa-trash-o" aria-hidden="true"></i>
             </a>
             :
             <a title="Restore" onClick={(event)=>  restoreUserPopup(userDetails.publisher_id) } href="javascript:void(0)" class="nav-restr">
                 {/* <i class="nc-icon nc-refresh-69"></i> */}
                 <FontAwesomeIcon icon={faTrashRestoreAlt} />
               </a> 
               }
               </td>
               :
               <td className="text-left"></td>
              }
               
            </tr>
        )
        i++;
    })
  }

  if(addUser){
    return (
      <AddUser projectId={projectId} projectName={projectDetails.name} setShowAddUser={setShowAddUser}/>
    );
  }else{
    return (
      <div className="content mt-30">
         {showPopup.alert}
        <Container>
          <Row>
          <Col className="ml-auto mr-auto"  md="12">
              <Card className="card-signup text-center dp-box">
                <CardHeader>
                <CardTitle tag="h4" className="heding_tab_h4">
                    Users associated with {projectDetails.name}
                </CardTitle>

                 <Button
                      style={{float: 'right'}}
                      className="btn-smb adUsr"
                      type="button"
                      onClick={(event)=>  setShowAddUser(true) }
                  >Add User</Button>
                  <Button
                      style={{float: 'right'}}
                      className="btn-smb inUsr"
                      type="button"
                      onClick={(event)=>  history.push("/project/invitedusers") }
                  >View Invited Users</Button>
                </CardHeader>
                <CardBody>
                <Table responsive>
                    <thead className="text-primary">
                     
                      <th className="text-left">#</th>   
                        <th className="text-left">Name</th>
                        <th className="text-left">Email</th>
                        <th className="text-left">Roles</th>
                        <th className="text-left">Status</th>
                        <th className="text-left">Action</th>
                      
                    </thead>
                    <tbody>{userElements}</tbody>
                  
                  </Table>
                </CardBody>
                {/* <CardFooter>
                </CardFooter> */}
              </Card>
            </Col>
          </Row>
        </Container>
        <div
          className="full-page-background"
          style={{
            backgroundImage: `url(${require("../../assets/img/bg/jan-sendereks.jpg")})`,
          }}
        />
      </div>
    );
  }
  
}

export default Users;
